import {DataTableColumn} from 'mantine-datatable';
import {I18n} from '@aws-amplify/core';
import {Text} from '@mantine/core';
import {PaymentEvent} from '../types';
import {formatTimestamp} from '../../../utils/TableTimestamps';
import {PaymentEventStatusBadge} from '../components/PaymentEventStatusBadge';

const formatAmount = (amount?: number, currency?: string) => {
    if (typeof amount !== 'number') return '';
    const display = (amount / 100).toFixed(2);
    return currency ? `${display} ${currency.toUpperCase()}` : display;
};

export const useTableColumns = () => {

    const columns: DataTableColumn<PaymentEvent>[] = [
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '0.8fr',
            render: (record: PaymentEvent) => <PaymentEventStatusBadge status={record.status}/>,
        },
        {
            accessor: 'amount',
            title: I18n.get('Amount'),
            width: '1fr',
            render: (record: PaymentEvent) => formatAmount(record.amount, record.currency),
        },
        {
            accessor: 'paymentMethodLast4',
            title: I18n.get('Card last 4'),
            width: '0.7fr',
            render: (record: PaymentEvent) => record.paymentMethodLast4 ? `•••• ${record.paymentMethodLast4}` : '',
        },
        {
            accessor: 'failureMessage',
            title: I18n.get('Failure reason'),
            width: '2fr',
            render: (record: PaymentEvent) => record.failureMessage ? (
                <Text size='sm' c='red'>{record.failureMessage}</Text>
            ) : '',
        },
        {
            accessor: 'occurredAt',
            title: I18n.get('Occurred at'),
            width: '1.2fr',
            render: (record: PaymentEvent) => record.occurredAt ? formatTimestamp(record.occurredAt) : '',
        },
    ];

    return {columns};
};
